/**
 * Composable for toast notifications
 *
 * Wraps vue-sonner for consistent toast API across the application.
 */

import { toast } from 'vue-sonner'

/**
 * Hook for displaying toast notifications
 * @returns {Object} - { showToast }
 */
export function useToast() {
  /**
   * Display a toast notification
   * @param {string} message - The message to display
   * @param {string} type - Toast type: 'success', 'error', 'info', 'warning'
   */
  function showToast(message, type = 'info') {
    switch (type) {
      case 'success':
        toast.success(message)
        break
      case 'error':
        toast.error(message)
        break
      case 'warning':
        toast.warning(message)
        break
      case 'info':
      default:
        toast.info(message)
        break
    }
  }

  return {
    showToast
  }
}
